import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { send_remainder_bulk_loading : true, send_remainder_bulk: '', send_remainder_bulk_error: false};

export function sendRemainderBulkReducer(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_ASSESSOR_GROUP_LIST:
        return {
            send_remainder_bulk_loading: true,
            send_remainder_bulk: '',
            send_remainder_bulk_error: false
        };
      case dashBoardConstants.RECIEVE_ASSESSOR_GROUP_LIST:
        return {
            send_remainder_bulk_loading: false,
            send_remainder_bulk: action.send_remainder_bulk,
            send_remainder_bulk_error: false
        };
      case dashBoardConstants.ERROR_ASSESSOR_GROUP_LIST:
        return { 
            send_remainder_bulk_loading: false,
            send_remainder_bulk: '',
            send_remainder_bulk_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/sendRemainderBulk.reducer.js